import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import { subgraphQuery, verifyChainConfig } from '../../../helpers';
import { EnabledChains, TradePair } from '../../../config/constants';
import { BigNumber } from 'ethers';
import useTokenDetails from '../useTokenDetails';
import { config } from '../../../config/config';
import { formatUnits } from 'ethers/lib/utils';
import moment from 'moment';

const useDailyVolume = () => {
    const { chainId } = useWeb3React();

    const { decimals } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const { data, error, mutate } = useSWR(
        chainId && decimals ? ['dailyVolume', chainId, decimals] : null,
        async (_, chainId, decimals) => {
            if (!verifyChainConfig(chainId)) return;

            const oneDayAgo = moment().subtract(25, 'hours');

            const query = `
                tradePairs {
                    id
                    dataMapping {
                        data(
                            where: {
                                periodType: HOURLY, 
                                startTimestamp_gt : ${oneDayAgo.unix()}
                            }
                        ) {
                            value
                            periodType
                        }
                    }
                }
            `;

            const data: { tradePairs: Pick<TradePair, 'id' | 'dataMapping'>[] } =
                await subgraphQuery(query, { chainId });

            let dailyVolume: Record<string, string> = {};

            data.tradePairs.map(({ dataMapping, id }) => {
                const totalVolume = dataMapping.data.reduce((total, { value }) => {
                    return total.add(value);
                }, BigNumber.from(0));

                dailyVolume[id.toLowerCase()] = formatUnits(totalVolume, decimals);

                return null;
            });

            return dailyVolume;
        }
    );

    return {
        dailyVolume: data,
        error,
        mutate,
    };
};

export default useDailyVolume;
